import { Button } from 'antd';
import moment from 'moment';
import React, { useEffect } from 'react';
// import './CampaignStatsComponent.styles.scss'

const CampaignStatsComponent = ({ className, campStats }) => {
  useEffect(() => {
    console.log('lvavav', campStats);
  }, []);
  return (
    <div className={`${className}`}>
      <div className="common_card admin_stats_camps p-3 h-100">
        <div className="admin_stats_camps_cards mt-0">
          <div className="admin_stats_camps_cards_each">
            <h5>Total Completed Campaigns</h5>
            <h4>{campStats.completed}<span>Campaigns</span></h4>
            <p>Latest {moment(campStats.updatedAt).format('Do MMM YYYY hh:mm a')}</p>
          </div>
          <div className="admin_stats_camps_cards_each">
            <h5>Total Active Campaigns</h5>
            <h4>{campStats.active}<span>Campaigns</span></h4>
            <p>Start date 18 Mar</p>
          </div>
          <div className="admin_stats_camps_cards_each">
            <h5>Total Approved Campaigns</h5>
            <h4>{campStats.approved}<span>Campaigns</span></h4>
            <p>1 Pending Payment</p>
          </div>
          <div className="admin_stats_camps_cards_each">
            <h5>Total Published Campaigns</h5>
            <h4>{campStats.published}<span>Campaigns</span></h4>
            <p>25/30 Influencers in Review</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignStatsComponent;
